import { render, staticRenderFns } from "./CheckMail.vue?vue&type=template&id=4c618228"
import script from "./CheckMail.vue?vue&type=script&lang=js"
export * from "./CheckMail.vue?vue&type=script&lang=js"
import style0 from "./CheckMail.vue?vue&type=style&index=0&id=4c618228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports